import './FilterList.scss'

import React from 'react'
import PropTypes from 'prop-types'
import UserItem from './UserItem'

const defaultRender = (filter) => <UserItem onDelete={filter.onDelete} user={filter.item} />

export const FilterList = (props) => {
  const { className, filters, renderMethod } = props
  const classes = `filter-list ${className}`.trim()
  return (
    <ul className={classes}>
      {filters.map((filter) => (
        <li key={filter.item.id} className='filter'>
          {filter.render ? filter.render(filter) : defaultRender(filter)}
        </li>
      ))}
    </ul>
  )
}

FilterList.defaultProps = {
  className: ''
}

FilterList.propTypes = {
  filters: PropTypes.array.isRequired,
  className: PropTypes.string
}

export default FilterList



// WEBPACK FOOTER //
// ./src/components/BoardFilterButton/FilterList/FilterList.js